export const errorCodes: { [key: string]: string } = {
    "-2460": "Entered odd exceeds the maximum amount"
}; 